/**
 * Pixel Shifting for Burn-in Prevention
 *
 * Periodically shifts the entire page content by small amounts to prevent
 * static image burn-in on displays (especially OLED/Plasma).
 */

const SHIFT_INTERVAL = 2 * 60 * 1000; // 2 minutes
const MAX_SHIFT = 2; // Maximum pixels to shift in any direction
const RESET_AFTER_SHIFTS = 10; // Reset to center after N shifts

let currentShiftX = 0;
let currentShiftY = 0;
let shiftCount = 0;
let shiftIntervalId = null;

/**
 * Apply pixel shift to the body element
 */
function applyShift(x, y) {
  document.body.style.transform = `translate(${x}px, ${y}px)`;
  currentShiftX = x;
  currentShiftY = y;
}

/**
 * Generate random shift within bounds
 */
function getRandomShift() {
  // Random shift between -MAX_SHIFT and +MAX_SHIFT
  const x = Math.floor(Math.random() * (MAX_SHIFT * 2 + 1)) - MAX_SHIFT;
  const y = Math.floor(Math.random() * (MAX_SHIFT * 2 + 1)) - MAX_SHIFT;
  return { x, y };
}

/**
 * Perform a pixel shift
 */
function performShift() {
  shiftCount++;

  // Reset to center every N shifts to prevent drift
  if (shiftCount >= RESET_AFTER_SHIFTS) {
    applyShift(0, 0);
    shiftCount = 0;
    return;
  }

  // Apply random shift
  const { x, y } = getRandomShift();
  applyShift(x, y);
}

/**
 * Start pixel shifting
 */
export function startPixelShift() {
  if (shiftIntervalId) {
    return;
  }

  // Initial shift after first interval
  shiftIntervalId = setInterval(performShift, SHIFT_INTERVAL);
}

/**
 * Stop pixel shifting and reset position
 */
export function stopPixelShift() {
  if (shiftIntervalId) {
    clearInterval(shiftIntervalId);
    shiftIntervalId = null;
    applyShift(0, 0);
    shiftCount = 0;
  }
}

/**
 * Get current shift status
 */
export function getShiftStatus() {
  return {
    enabled: shiftIntervalId !== null,
    currentX: currentShiftX,
    currentY: currentShiftY,
    shiftCount,
    intervalSeconds: SHIFT_INTERVAL / 1000,
  };
}
